import { gql } from '../../../../__generated__/graphql/catalog'

export const ORG_IDENTITY_QUERY = gql(`
  query OrganizationIdentity {
    my {
      id
      portal {
        id
      }
      organizations {
        ...OrganizationMinimalFields
      }
    }
  }
`)
